export const iframeQueryMaker = (address, city, province) => {
  return (
    address?.split(' ')?.join('+') + '+' + city + '+' + province + '+Canada'
  );
};
